import React from 'react';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white sticky-footer">
      <div className="container my-auto">
        <div className="text-center my-auto copyright">
          <span>Copyright © GROUPING-ADMIN {currentYear}</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
